import * as React from "react";
import { connect } from "react-redux";
import { CustomerGroupFilterState } from "src/types";

import {
  CustomerGroupBody,
  CustomerGroupData,
} from "../../lib/models/CustomerGroup";
import { Dispatch, StoreState } from "../../store";
import MyTable from "./MyTable";

function mapStateToProps({
  customerGroupFilter,
  customerGroupResult,
}: StoreState) {
  return {
    customerGroupFilter,
    customerGroupResult,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchCustomerGroup: (
      customerGroupFilter: CustomerGroupFilterState,
      page?: number,
      rowsPerPage?: number,
      filter?: { [field: string]: string },
      sortBy?: string,
      sortDirection?: string
    ) =>
      dispatch.customerGroupResult.fetchCustomerGroup({
        customerGroupFilter,
        page,
        rowsPerPage,
        filter,
        sortBy,
        sortDirection,
      }),
    saveCustomerGroup: (groupName: string) =>
      dispatch.customerGroupList.saveCustomerGroup(groupName),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> & {
    getDownloadHref?: (
      tableFilter?: { [field: string]: string },
      sortBy?: string,
      sortDirection?: string
    ) => string;
  };

class CustomerGroupView extends React.Component<Props> {
  public render() {
    return (
      <MyTable
        data={this.adaptForTableView(this.props.customerGroupResult)}
        getDownloadHref={this.props.getDownloadHref}
        fetchData={this.fetchData}
      />
    );
  }

  private adaptForTableView = (
    customerGroupResult: CustomerGroupBody
  ): CustomerGroupBody => {
    const customerGroupResultDataAdapted = customerGroupResult.data.map(
      (data: CustomerGroupData & { customer_age: number | null }) =>
        data.customer_age ? { ...data, age_predicted: null } : data
    );
    return { ...customerGroupResult, data: customerGroupResultDataAdapted };
  };

  private fetchData = (
    page?: number,
    rowsPerPage?: number,
    filter?: { [field: string]: string },
    sortBy?: string,
    sortDirection?: string
  ) => {
    this.props.fetchCustomerGroup(
      this.props.customerGroupFilter,
      page,
      rowsPerPage,
      filter,
      sortBy,
      sortDirection
    );
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerGroupView);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/GroupDetailsView.tsx